import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import QrMaderas from './components/homes/qr/cdmaderas/QrMaderas';
import Error404Screen from './components/homes/Error404/Error404';
import i18n from './i18n'; 
const router = createBrowserRouter([
  {
    path: "/cdmaderas/:token",
    element: <App />
  },
  {
    path: "/living/:token",
    element: <App />
  },
  {
    path: "/segura/:token",
    element: <App />
  },
  {
    path: "/cdmaderas/qr/:token",
    element: <QrMaderas />
  },
  {
    path: "/living/qr/:token",
    element: <QrMaderas />
  },
  {
    path: "*",
    element: <Error404Screen />
  },
], {
  future: {
    v7_fetcherPersist: true,
    v7_normalizeFormMethod: true,
    v7_partialHydration: true,
    v7_relativeSplatPath: true,
    v7_skipActionErrorRevalidation: true,
  },
});
const root = ReactDOM.createRoot(document.getElementById('root'));
document.documentElement.style.setProperty(
  "--maderas-background-image",
  `url("${process.env.PUBLIC_URL}/background2.png")`
);
const params = new URLSearchParams(window.location.search);
const langParam = params.get('lang');

i18n.init({
  lng: langParam, 
  supportedLngs: ['es', 'en'],
  fallbackLng: 'es',
  backend: {
    loadPath: '/locales/{{lng}}/translation.json',
  },
  react: {
    useSuspense: false,
  },
  debug: true,
})
.then(() => {
  root.render(
    <React.StrictMode>
      <RouterProvider
        router={router}
        future={{ v7_startTransition: true }}
      />
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
